module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-content-toyota.c1505a6d.jpg";